
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductFranchiseeShareDialog extends Serenity.EntityDialog<ProductFranchiseeShareRow, any> {
        protected getFormKey() { return ProductFranchiseeShareForm.formKey; }
        protected getIdProperty() { return ProductFranchiseeShareRow.idProperty; }
        protected getLocalTextPrefix() { return ProductFranchiseeShareRow.localTextPrefix; }
        protected getService() { return ProductFranchiseeShareService.baseUrl; }
        protected getDeletePermission() { return ProductFranchiseeShareRow.deletePermission; }
        protected getInsertPermission() { return ProductFranchiseeShareRow.insertPermission; }
        protected getUpdatePermission() { return ProductFranchiseeShareRow.updatePermission; }

        protected form = new ProductFranchiseeShareForm(this.idPrefix);

    }
}